// import { handleResponse, handleError } from "./apiUtils";

import { API_BASE_URI, jsonBasedFetch } from "./apiUtils";

export function getTariff() {
  return jsonBasedFetch(`${API_BASE_URI}/tariffs/me`);
}
